<template>
  <div class="order-submission">
    <div class="allAddress" :style="store_self_mention ? '' : 'padding-top: 0.2rem'">
      <div class="nav acea-row">
        <div class="item font-color-red" :class="shipping_type === 0 ? 'on' : 'on2'" @click="addressType(0)"
          v-if="store_self_mention"></div>
        <div class="item font-color-red" :class="shipping_type === 1 ? 'on' : 'on2'" @click="addressType(1)"
          v-if="store_self_mention"></div>
      </div>
      <div class="address acea-row row-between-wrapper" v-if="shipping_type === 0" @click="addressTap">
        <div class="addressCon" v-if="addressInfo.real_name">
          <div class="name">
            {{ addressInfo.real_name }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div class="addr-text">
            <span class="default font-color-red" v-if="addressInfo.is_default">[默认]</span>
            {{ addressInfo.province }}{{ addressInfo.city
            }}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
        </div>
        <div class="addressCon" v-else>
          <div class="setaddress">设置收货地址</div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="address acea-row row-between-wrapper" v-else @click="showStoreList">
        <div class="addressCon">
          <div class="name" v-if="storeItem">
            {{ storeItem.name }}
            <span class="phone" v-text="storeItem.phone"></span>
          </div>
          <div class="addr-text" v-text="storeItem.address + ',' + storeItem.detailed_address"
            v-if="storeItem && storeItem.address && storeItem.detailed_address"></div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <!-- <div class="item acea-row row-between-wrapper" @click="couponTap" v-if="deduction === false">
        <div>优惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "请选择" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div> -->
      <!-- <div class="item acea-row row-between-wrapper" v-if="deduction === false">
        <div>积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegral" />
                <i class="icon"></i>
                <span class="integral">
                  当前积分
                  <span class="num font-color-red">
                    {{ userInfo.integral || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="item acea-row row-between-wrapper" v-if="
        orderGroupInfo.priceGroup.vipPrice > 0 &&
        userInfo.vip &&
        pinkId == 0 &&
        orderGroupInfo.bargain_id == 0 &&
        orderGroupInfo.combination_id == 0 &&
        orderGroupInfo.seckill_id == 0
      ">
        会员优惠
        <div class="discount">-￥{{ orderGroupInfo.priceGroup.vipPrice }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="shipping_type === 0">
        <div>快递费用</div>
        <div class="discount">
          {{
          orderPrice.pay_postage > 0
          ? "￥" + orderPrice.pay_postage
          : "免运费"
          }}
        </div>
      </div>
      <div v-else>
        <div class="item acea-row row-between-wrapper">
          <div>联系人</div>
          <div class="discount">
            <input type="text" placeholder="请填写您的联系姓名" v-model="contacts" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>联系电话</div>
          <div class="discount">
            <input type="text" placeholder="请填写您的联系电话" v-model="contactsTel" />
          </div>
        </div>
      </div> -->
      <div class="item acea-row row-between-wrapper">
        <div class="mark-label">备注信息</div>
        <input type="text" class="mark-input" placeholder="留言前请先与商家沟通" v-model="mark"/>
      </div>
    </div>
    <div class="wrapper">
      <div class="item">
        <div>支付类型</div>
        <div class="list">
          <div class="payItem acea-row row-middle"
            :class="[active === index ? 'on' : '', (active === index && item.installments.length > 0) ? 'with-plan' : '']"
            v-for="(item, index) in cartArr" :key="index" @click="payItem(index)">
            <div class='name acea-row row-center-wrapper'>
              <div class="iconfont" :class="active === index ? 'bounceIn ' + item.icon : item.icon"></div>
              {{ item.name }}
            </div>
            <div class='tip'>{{ item.title }}</div>
          </div>
        </div>
        <div class="installmentsInfo" v-if="cartArr[active].installments.length > 0">
          <div class="installment-head">
            <span class="term">期数</span>
            <span class="amount">待结金额</span>
            <span class="deadline">还款日期</span>
          </div>
          <div class="installment-list">
            <div
              class="installment-row"
              v-for="(item, index) in selectedInstallment.installmentInfos"
              :key="index"
            >
              <span class="term">{{ item.termIndex }}</span>
              <span class="amount">{{ item.amount }}</span>
              <span class="deadline">{{ item.payDeadline }}</span>
            </div>
          </div>
          <div class="info" v-if="interestRate!='0'">注：逾期日利率{{ interestRate }}</div>
        </div>
      </div>
    </div>
    <div class="moneyList">
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.total_price !== undefined">
        <div>商品总价：</div>
        <div class="money">￥{{ orderPrice.total_price }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.pay_postage > 0">
        <div>运费：</div>
        <div class="money">+￥{{ orderPrice.pay_postage }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.coupon_price > 0">
        <div>优惠券抵扣：</div>
        <div class="money">-￥{{ orderPrice.coupon_price }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.deduction_price > 0">
        <div>积分抵扣：</div>
        <div class="money">-￥{{ orderPrice.deduction_price }}</div>
      </div>
    </div>

    <div style="height:2.6rem"></div>
    <div class="footer">
      <div class="agree-row acea-row row-middle">
        <div class="checkbox-wrapper">
          <label class="well-check">
            <input type="checkbox" v-model="agreeChecked" />
            <i class="icon"></i>
          </label>
        </div>
        <div class="agree-text">
          <span class="agree-label" @click="agreeChecked = !agreeChecked"
            >我已阅并同意</span
          >
          <span
            class="agree-link font-color-red"
            @click.stop="goTerms('auth_service')"
            >《认证服务协议》</span
          ><span
            class="agree-link font-color-red"
            @click.stop="goTerms('user_register')"
            >《用户协议》</span
          >和<span
            class="agree-link font-color-red"
            @click.stop="goTerms('privacy')"
            >《隐私协议》</span
          >
        </div>
      </div>
      <div class="footer-bar acea-row row-between-wrapper">
        <div>
          合计:
          <span class="font-color-red">￥{{ orderPrice.pay_price }}</span>
        </div>
        <div class="settlement" @click="createOrder">提交订单</div>
      </div>
    </div>
    <CouponListWindow v-on:couponchange="changecoupon($event)" v-model="showCoupon" :price="orderPrice.total_price"
      :checked="usableCoupon.id" :cartid="cartid" @checked="changeCoupon"></CouponListWindow>
    <AddressWindow @checked="changeAddress" @redirect="addressRedirect" v-model="showAddress" :checked="addressInfo.id"
      ref="mychild"></AddressWindow>
  </div>
</template>
<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}

.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}

.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(to bottom,
      #e93323 0%,
      #f5f5f5 100%);
  background-image: -moz-linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  padding-top: 1rem;
}

.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .allAddress .nav .item {
  width: 3.55rem;
}

.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}

.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "快递配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}

.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}

.order-submission .allAddress .nav .item.on2 {
  position: relative;
}

.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}

.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "快递配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}

.order-submission .allAddress .address {
  width: 7.1rem;
  min-height: 1.5rem;
  height: auto;
  margin: 0 auto;
  flex-wrap: nowrap;
}

.order-submission .allAddress .address .addressCon {
  flex: 1;
  min-width: 0;
  width: auto;
}

.order-submission .allAddress .address .addr-text {
  word-break: break-all;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
}

.order-submission .allAddress .address .iconfont {
  flex-shrink: 0;
}

.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}

.order-submission .wrapper .item .mark-label {
  flex-shrink: 0;
  margin-right: 0.24rem;
}

.order-submission .wrapper .item .mark-input {
  flex: 1;
  min-width: 0;
  width: auto;
  text-align: right;
  font-size: 0.28rem;
}

.order-submission .wrapper .item .list .payItem.with-plan {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.order-submission .installmentsInfo {
  border-left: 1px solid #fc5445;
  border-right: 1px solid #fc5445;
  border-bottom: 1px solid #fc5445;
  border-bottom-left-radius: 0.06rem;
  border-bottom-right-radius: 0.06rem;
  width: 100%;
  box-sizing: border-box;
  margin-top: -0.03rem;
  padding: 0.08rem 0.16rem 0.14rem;
  background: #fff8f7;
}

.order-submission .wrapper .item .installmentsInfo .installment-head,
.order-submission .wrapper .item .installmentsInfo .installment-row {
  display: grid;
  grid-template-columns: 0.9fr 1.2fr 1.4fr;
  align-items: center;
  justify-items: center;
  column-gap: 0.08rem;
  font-variant-numeric: tabular-nums;
  text-align: center;
}

.order-submission .wrapper .item .installmentsInfo .installment-head {
  font-size: 0.22rem;
  color: #999;
  padding: 0.08rem 0.12rem 0.1rem;
}

.order-submission .wrapper .item .installmentsInfo .installment-list {
  background: #fff;
  border-radius: 0.08rem;
  overflow: hidden;
}

.order-submission .wrapper .item .installmentsInfo .installment-row {
  font-size: 0.26rem;
  padding: 0.12rem;
  color: #666;
}

.order-submission .wrapper .item .installmentsInfo .installment-row + .installment-row {
  border-top: 1px solid #f5f0ef;
}

.order-submission .wrapper .item .installmentsInfo .installment-row .term {
  color: #999;
  font-size: 0.24rem;
}

.order-submission .wrapper .item .installmentsInfo .installment-row .amount {
  color: #e93323;
  
}

.order-submission .wrapper .item .installmentsInfo .installment-row .deadline {
  color: #868686;
  white-space: nowrap;
}

.order-submission .wrapper .item .installmentsInfo .info {
  text-align: center;
  font-size: 0.22rem;
  color: #e93323;
  padding: 0.12rem 0.12rem 0;
  line-height: 1.4;
}

 input::placeholder {
  color: #ccc; 
}

.order-submission .footer {
  height: auto;
  padding: 0.28rem 0.3rem 0;
}

.agree-row {
  margin-bottom: 0.08rem;
}

.agree-row .checkbox-wrapper {
  width: 0.36rem;
  height: 0.36rem;
  flex-shrink: 0;
}

.agree-row .well-check {
  display: block;
  position: relative;
  width: 0.36rem;
  height: 0.36rem;
}

.agree-row .well-check .icon {
  top: 50%;
}

.agree-text {
  margin-left: 0.14rem;
  font-size: 0.22rem;
  color: #999;
  line-height: 1.5;
}

.agree-label {
  cursor: pointer;
}

.agree-link {
  display: inline;
}

.footer-bar {
  height: 1.4rem;
  padding: 0 0 0.2rem;
  box-sizing: border-box;
}
</style>

<script>
import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { storeListApi } from "@api/store";
import { getUser } from "@api/user";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow
  },
  props: {},
  computed: {
    ...mapGetters(["storeItems"]),
    storeItem: function () {
      if (JSON.stringify(this.storeItems) == "{}") {
        return this.storeList;
      } else {
        return this.storeItems;
      }
    }
  },
  data: function () {
    return {
      cartid: "",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: 0,
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中"
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      userInfo: {},
      storeList: {},
      cartArr: [
        {
          name: "全款购买",
          icon: "icon-zhifubao",
          value: "quanKuan",
          title: "支付宝安全支付",
          payType: "alipay",
          installments: []
        }
      ],
      installmentsInfo: [],
      interestRate: '0',      //分期利率
      buyMethod:'quanKuan',   //购买方式
      selectedInstallment:{}, //选中分期
      payType:'weixin',       //支付方式
      agreeChecked: false
    };
  },
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) {
        console.log(this.$route.query.pinkid);
        if (this.$route.query.pinkid !== undefined)
          this.pinkId = this.$route.query.pinkid;
        else {
          this.pinkId = 0;
        }
        this.getUserInfo();
        this.getCartInfo();
      }
    },
    shipping_type() {
      this.computedPrice();
    }
  },
  mounted: function () {
    let that = this;
    that.getUserInfo();
    that.getCartInfo();
    that.getList();
    if (this.$route.query.pinkid !== undefined)
      this.pinkId = this.$route.query.pinkid;
    if (that.$route.params.id !== undefined)
      that.cartid = that.$route.params.id;
  },
  methods: {
    // 获取门店列表数据
    getList: function () {
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: 1,
        limit: 10
      };
      // storeListApi(data)
      //   .then(res => {
      //     this.storeList = res.data.list[0];
      //   })
      //   .catch(err => {
      //     this.$dialog.error(err.msg);
      //   });
    },

    // 跳转到门店列表
    showStoreList() {
      this.$store.commit("GET_TO", "orders");
      this.$router.push("/shop/storeList/orders");
    },

    getUserInfo() {
      getUser()
        .then(res => {
          this.userInfo = res.data;
        })
        .catch(() => { });
    },
    addressType: function (index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
    },

    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1,
        payType: this.payType
      })
        .then(res => {
          const data = res.data;
          if (data.status === "EXTEND_ORDER") {
            this.$router.replace({
              path: "/order/detail/" + data.result.orderId
            });
          } else {
            this.orderPrice = data.result;
          }
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },

    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then(res => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.interestRate = res.data.interest_rate;
          this.cartArr = res.data.pay_type_arr;
          //this.active = 0;
          //this.buyMethod = res.data.pay_type_arr[0].value;
          //this.payType = res.data.pay_type_arr[0].payType
          //this.computedPrice();
          this.payItem(res.data.pay_type_arr.length > 1 ? 1 : 0);
          if(res.data.tipMsg != '') {
            setTimeout(() => {
              this.$dialog.toast({
                mes: res.data.tipMsg,
                timeout: 4000
              });
            }, 600);
      }
        })
        .catch(err => {
            this.$dialog.error("加载订单数据失败");
            if(err.data.status === 400) {
              setTimeout(() => {
                this.$router.replace({ path: '/order/list/' })
              }, 1500);
            }
          }
        );
    },

    addressTap: function () {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },

    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },

    couponTap: function () {
      this.showCoupon = true;
    },

    changeCoupon: function (coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },

    payItem: function (index) {
      let that = this;
      let active = index;
      if (that.cartArr[active].installments.length > 1) { //有多种分期方式【暂时不会有】

      }
      else {
        let oldActive = that.active;
        if (that.cartArr[oldActive].installments.length > 1) { //有多种分期方式，才需要重置提示语
          that.cartArr[oldActive].title = '点击选择期数';
          that.cartArr[oldActive].value = '';
        }
        if (that.cartArr[active].installments.length == 1) { //只有一种分期方式
          that.selectedInstallment = that.cartArr[active].installments[0];
        } else { //不是分期购买
          that.selectedInstallment = {};
        }
        that.active = active;
        that.buyMethod = that.cartArr[active].value;
        that.payType = that.cartArr[active].payType;
        //that.cartArr = that.cartArr;
      }
    
      that.computedPrice();
    },

    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();
    },

    goTerms(type) {
      this.$router.push({ path: `/user/service_terms/${type}` });
    },

    createOrder() {
      let shipping_type = this.shipping_type;
      if (!this.buyMethod) {
        return this.$dialog.toast({ mes: "请选择支付方式" });
      }
      if (this.userInfo.auth_status != 2) {
        this.$dialog.confirm({
          mes: "您还无法购买，请先去完成实名认证！",
          title: "温馨提示",
          opts: [
            {
              txt: "取消",
              color: false,
              callback: () => { }
            },
            {
              txt: "去认证",
              color: true,
              callback: () => {
                this.$router.push({ path: '/user/binding' });
              }
            }
          ]
        });
        return;
      }
      if (!this.addressInfo.id && !this.shipping_type) {
        return this.$dialog.toast({ mes: "请选择收货地址" });
      }
      if (this.shipping_type) {
        if (
          (this.contacts === "" || this.contactsTel === "") &&
          this.shipping_type
        )
          return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写您的真实姓名" });
        }
      }
      if (!this.agreeChecked) {
        return this.$dialog.toast({
          mes: "请先阅读并同意相关协议"
        });
      }
      this.$dialog.loading.open("订单提交中");
      createOrder(this.orderGroupInfo.orderKey, {
        real_name: this.contacts,
        phone: this.contactsTel,
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        payType: this.payType,
        buyMethod: this.buyMethod,
        pinkId: this.pinkId,
        seckill_id: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        from: this.from,
        mark: this.mark || "",
        shipping_type: parseInt(shipping_type) + 1,
        store_id: this.storeItem ? this.storeItem.id : 0
      })
        .then(res => {
          this.$dialog.loading.close();
          const data = res.data;
          let url = "/order/status/" + data.result.orderId;
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: res.msg });
              this.$router.replace({
                path: url + "/0?msg=" + res.msg
              });
              break;
            case "SUCCESS":
              this.$dialog.success(res.msg);
              this.$router.replace({
                path: url + "/1?msg=" + res.msg
              });
              break;
            case "ALIPAY":
              // console.info('=====>' + data.result.jsConfig)
              // this.$router.replace({
              //   path: url + "/2"
              // });
              // setTimeout(() => {
              //   location.href = data.result.jsConfig;
              // }, 100);
              location.href = data.result.jsConfig;
              break;
            case "WECHAT_H5_PAY":
              this.$router.replace({
                path: url + "/2"
              });
              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                this.$router.replace({
                  path: url + "/4"
                });
              });
          }
        })
        .catch(err => {
          this.$dialog.error(err.msg || "创建订单失败");
          this.$dialog.loading.close();
          this.$router.go(-1);
        });
    }
  }
};
</script>
